<!-- prize.wxml -->
<template>
    <div class="member-return-goods">
        <!-- 商品信息 -->
        <div style="height: 15px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
        <div class="goods-box clearfix">
            <div class="goods-list clearfix" @click="toDetail">
                <div class="image">
                    <nut-uploader></nut-uploader>
                    <img :src="detail.image.file_path" width="80%" class="skeleton-rect">
                </div>
                <div class="goods-detail skeleton-rect">
                    <div class="title skeleton-rect">{{detail.goods_name}}</div>
                    <div class="price-box">
                        <div class="total-price">
                        </div>
                        <div class="num skeleton-rect">X {{detail.total_num}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 商品信息 -->
        <div style="height: 15px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
        <!-- detsil -->
        <div class="return-detail">
            <div class="form-item">
                <div class="title">服务类型</div>
                <div class="radio-group clearfix">
                    <div :class="['radio-box',item.type == serviceType ? 'radio-active' : '']"
                         v-for="(item,index) in typeList" :key="index">
                        <input type="radio" :id="'radio' + index" :value="item.type" v-model="serviceType"/>
                        <label :for="'radio' + index">
                            <div class="text">{{item.name}}</div>
                        </label>
                    </div>
                </div>
            </div>
            <div style="height: 15px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
            <div class="divider-line"></div>
            <div class="form-item">
                <div class="title">申请原因</div>
                <div class="reason">
                    <textarea v-model="reason" id="reason" cols="30" rows="10"
                              placeholder="请详细填写申请原因 建议您先与卖家沟通"></textarea>
                </div>
            </div>
            <div style="height: 15px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
            <div class="row-money" v-if="serviceType == 10">
                <div class="title">退款金额
                    <span class="money">${{ detail.total_pay_price }}</span>
                </div>
                <div style="height: 15px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
            </div>
            <div class="divider-line"></div>
            <div class="form-item">
                <div class="title">上传凭证（最多6张）</div>
                <div class="upload-images">
                    <nut-imagepicker
                        @imgMsg="imgMsg"
                        :width="imageWidth"
                        :height="imageHeight"
                        :margin="5"
                        :imgList.sync="images"
                        :max="6"
                    >
                    </nut-imagepicker>
                </div>
            </div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <button @click="returnForm" class="submit-btn">确认提交</button>
        </div>
        <!-- detail end -->
    </div>
</template>
<script>
    import Tabber from '@/components/Tabber.vue'
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    export default {
        name: 'MemberReturnGoods',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                order_goods_id: 0,
                imageHeight: 110,
                imageWidth: 110,
                isUpload: true, //是否上传
                disable: false, //阻止重复提交
                reason: '',
                // 订单商品详情
                detail: {
                    image: {
                        file_path: ''
                    }
                },
                // 服务类型
                serviceType: 10,
                typeList: [
                    {
                        type: 10,
                        name: '退货退款',
                    },
                    {
                        type: 20,
                        name: '换货',
                    },
                ],
                images: [],
                cacheImages:[],
                uploadImgs: []
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('正在加载', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.order_goods_id = _this.$route.query.order_goods_id;
            _this.getGoodsDetail();
        },
        methods: {

            /**
             * 获取订单商品详情
             */
            getGoodsDetail: function () {
                let _this = this;
                _this._get('user.refund/apply', {
                    order_goods_id: this.order_goods_id
                }, function (result) {
                    _this.loading.hide();
                    console.log(result.data);
                    _this.setData(result.data);
                });
            },

            // 去商品详情
            toDetail() {
                let _this = this;
                _this.navigationTo('/goods/show', {goods_id: _this.detail.goods_id});
            },

            // 图片处理
            imgMsg(data) {
                let _this = this;
                if(data.code == 2){
                    _this.cacheImages = _this.images;
                    data.msg.forEach((item,index) => {
                        getBase64(item).then(val=>{
                            if(_this.images.indexOf(val)){
                                _this.uploadImgs.push(item);
                            }
                        });
                    });
                }
                if(data.code == 3){
                    _this.cacheImages.forEach((item,index) => {
                        if(item.id == data.msg){
                            _this.uploadImgs.splice(index,1);
                        }
                    });
                }
            },

            /**
             * 提交退款
             */
            returnForm: function () {
                let _this = this;
                this.loading = this.$toast.loading('Loading...', {
                    coverColor: "rgba(0,0,0,0.5)",
                });
                if (_this.reason == "") {
                    _this.$toast.warn('请输入退款申请原因');
                    return false;
                }
                // 判断是否重复提交
                if (_this.disable === true) {
                    return false;
                }
                // 表单提交按钮设为禁用 (防止重复提交)
                _this.disable = true;
                // form参数
                let postParams = {
                    order_goods_id: _this.order_goods_id,
                    type: _this.serviceType,
                    content: _this.reason,
                };

                // form提交执行函数
                let fromPostCall = function (params) {
                    _this._post_form('user.refund/apply', params, function (result) {
                        if (result.code === 1) {
                            // 跳转售后管理页面
                            _this.$toast.success(result.msg,{onClose:function () {
                                    _this.navigationTo('/order/refund/index');
                                }});
                        } else {
                            _this.$toast.fail(result.msg);
                        }
                    });
                };
                // 统计图片数量
                let imagesLength = _this.uploadImgs.length;

                // 判断是否需要上传图片
                imagesLength > 0 ? _this.uploadFile(imagesLength, fromPostCall, postParams) : fromPostCall(postParams);

            },
            /**
             * 上传图片
             */
            uploadFile: function (imagesLength, callBack, formData) {
                let _this = this;
                let uploaded = [];
                // 文件上传
                let i = 0;
                _this.uploadImgs.forEach(function (item, Key) {
                    let form = new FormData();
                    form.append('iFile', item);
                    _this._post_form('upload/image', form, (res) => {

                        if (res.code === 1) {
                            let result = typeof res.data === "object" ? res.data : JSON.parse(res.data);
                            uploaded[Key] = result.file_id;
                        }
                        i++;
                        if (imagesLength === i) {
                            // 所有文件上传完成
                            formData['images'] = uploaded.join(',');
                            // 执行回调函数
                            callBack && callBack(formData);
                        }
                    });
                });
            },
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss">
    @import "return_goods.scss";
</style>
